import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAndSanitize } from '../utils/sanitization';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const token = getAndSanitize('token');
  const role = getAndSanitize('role');
  
  // Verificar si existe token
  if (!token) {
    console.warn('[SuperAdminRoute] No token found, redirecting to login');
    return <Navigate to="/" />;
  }
  
  // Verificar si el rol es SUPERADMIN
  if (role !== 'SUPERADMIN') {
    console.warn(`[SuperAdminRoute] Access denied. User role: ${role}, required: SUPERADMIN`);
    return <Navigate to="/user-panel" />;
  }

  return <>{children}</>;
}; 